/**
 * CREProtectedRoute — Auth gate for CRE Pro routes.
 *
 * Same logic as ProtectedRoute but redirects to /commercial/login
 * instead of /login, preserving the commercial context.
 */

import React from "react";
import { Navigate, useLocation } from "react-router";
import { useAuthContext } from "../../../contexts/AuthContext";

interface CREProtectedRouteProps {
  children: React.ReactNode;
}

export function CREProtectedRoute({ children }: CREProtectedRouteProps) {
  const { isAuthenticated, isLoading } = useAuthContext();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center">
        <p className="text-sm text-slate-400">Loading…</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    return (
      <Navigate
        to={`/commercial/login?redirect=${encodeURIComponent(location.pathname)}`}
        replace
      />
    );
  }

  return <>{children}</>;
}
